<h1 mat-dialog-title>{{data.title | translate}}</h1>
<mat-dialog-content>
  {{data.message | translate}}
  @if (data.message2) {
    <div>
      <br>{{data.message2 | translate}}
      </div>
    }
  </mat-dialog-content>
  @if (isCancelButtonDefault()) {
    <mat-dialog-actions align="end">
      <button mat-button [mat-dialog-close]="true">{{'DIALOGS.OK' | translate}}</button>
      <button mat-button [mat-dialog-close]="false" cdkFocusInitial>{{'DIALOGS.CANCEL' | translate}}</button>
    </mat-dialog-actions>
  }
  @if (!isCancelButtonDefault()) {
    <mat-dialog-actions align="end">
      <button mat-button [mat-dialog-close]="true" cdkFocusInitial>{{'DIALOGS.OK' | translate}}</button>
      <button mat-button [mat-dialog-close]="false">{{'DIALOGS.CANCEL' | translate}}</button>
    </mat-dialog-actions>
  }
